import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChartBar, faList, faHandshake, faMoneyBill, faCog,
    faExclamationCircle, faPaperclip, faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons';
import HighchartMore from "highcharts-more";
import ReactHighcharts from "react-highcharts";


import Sidebar from './containers/general/sidebar';
import PageNotFound from './components/pageNotFound';
import SiteVisits from './containers/site-visits';
import {fetchUserStations, fetchUserDetails} from "./actions/user_actions";
import {screenResize} from "./actions/mobile_actions";
import DashboardSLP from "./containers/dashboard-spl/DashboardSLP";

library.add(faChartBar);
library.add(faList);
library.add(faHandshake);
library.add(faMoneyBill);
library.add(faCog);
library.add(faExclamationCircle);
library.add(faPaperclip);
library.add(faSignOutAlt);
library.add(faBars);

class App extends Component {

    componentWillMount(){
        this.updateDimensions();
        HighchartMore(ReactHighcharts.Highcharts);
    }

    componentDidMount(){
        // TODO - Detect with cookie if user is logged
        this.props.fetchUserDetails();
        this.props.fetchUserStations();
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    };

    updateDimensions = () => {
        let w = window,
            d = document,
            documentElement = d.documentElement,
            body = d.getElementsByTagName('body')[0],
            width = w.innerWidth || documentElement.clientWidth || body.clientWidth,
            height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
        this.setState({width, height});
        this.props.screenResize(width);
    };

    render() {
        return (
            <div className="react-app">
                <Sidebar />
                <div className={"main-body"}>
                    <Router>
                        <Switch>
                            <Route exact path={'/'} component={SiteVisits} />
                            <Route exact path={'/site-visits'} component={SiteVisits} />
                            <Route exact path={'/dashboard-slp'} component={DashboardSLP} />
                            <Route path="*" component={PageNotFound} />
                        </Switch>
                    </Router>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({fetchUserStations, fetchUserDetails, screenResize}, dispatch);
};

export default connect(null, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js